import { useMemo } from 'react';
import useSWR from 'swr';
import { HandlersSimProfileDetailsResponse } from 'types/__generated__/SimInventoryApi';
import getFetcher from 'api/utils/getFetcher';
import { ApiBaseError } from '../utils/shared';

export interface SimProfilesResultError extends ApiBaseError {}

const useSimProfiles = (hologramSimId?: HologramSimId) => {
  const url = hologramSimId
    ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${hologramSimId}/profiles`
    : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    HandlersSimProfileDetailsResponse,
    SimProfilesResultError
  >(url, getFetcher);

  const simProfiles = useMemo(() => {
    if (!data?.simProfileDetails) {
      return [];
    }

    const newSimProfiles = structuredClone(data.simProfileDetails);

    return newSimProfiles.sort((a, b) => {
      if (a.profileType === 'OPERATIONAL' && b.profileType !== 'OPERATIONAL') {
        return -1;
      }

      if (a.profileType !== 'OPERATIONAL' && b.profileType === 'OPERATIONAL') {
        return 1;
      }

      return (a.simProfileId ?? 0) < (b.simProfileId ?? 0) ? -1 : 1;
    });
  }, [data]);

  return {
    simProfiles,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useSimProfiles;
